<template>
	<view class="select-main">
		<view wx:if="{{limit}}" class="notice"><es-icon name="exclamation-circle" size="12" />{{notice}}</view>
		<view bindtap="handleClick('station')" class="select-item">
			<view class="select-item-title">到达站</view>
			<view wx:class="{{ {'select-item-value':true,disabled:(limit || isCross)} }}">{{toStation}}</view>
			<es-icon class="select-item-icon" color="#dddddd" name="angle-right" size="20" />
		</view>
		<view bindtap="handleClick('date')" class="select-item">
			<view class="select-item-title">出发日期</view>
			<view class="select-item-value">{{ticketDate.t}}<view class="week">{{ticketDate.w}}</view></view>
			<es-icon class="select-item-icon" color="#dddddd" name="angle-right" size="20" />
		</view>
		<es-button disabled="{{!toStation}}" custom-class="submit-button active" bind:click="handleClick('toTicket')">查看可改签车次</es-button>
	</view>
</template>
<script>
	import { createComponent, mpx } from '@didi/es-mpx-creator'
  	import { formatDate, getFullDate } from '@/utils/baseDate'

createComponent({
	props: {
		startTime: {
			type: Array | Number,
			value: []
		},
		toStation: {
			type: String,
			value: ''
		},
		limit: {
			type: Boolean,
			value: false
		},
		isCross: {
			type: Boolean,
			value: false
		},
		notice: {
			type: String,
			value: '距发车时间不足48小时，不可办理变更到站'
		}
	},
	computed: {
		ticketDate() {
			return this.toStation && this.startTime?.length ? {
				t: formatDate(this.startTime?.[0], 'MM月dd日'),
				w: this.startTime ? `周${getFullDate(this.startTime?.[0])?.weekName}` : ''
			} : {}
		}
	},
	methods: {
		handleClick(type) {
			this.$trigger('handleClick', {type})
		}
	}
})
</script>
<style lang='stylus' scoped>
	$current-main-color = #FF7C46

	.select-main
		box-sizing border-box
		border-radius: 16px;
		background: #FFFFFF;
		box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.04);
		padding 12px 16px 20px
		margin 10px 0
		.notice
			height 32px
			display flex
			box-sizing border-box
			align-items center
			padding 9px 12px
			background rgba(255, 244, 238, 0.5)
			border-radius 8px
			color $current-main-color
			font-family PingFangSC-Regular
			font-size 12px
			font-weight normal
			line-height 14px
			letter-spacing 0px
			>>> .es-icon
				margin-right 4px
		.select-item
			height 52px
			border-bottom 1px solid #eee
			display flex
			align-items center
			color #666666
			font-family: PingFangSC-Regular;
			font-size: 12px;
			font-weight: normal;
			line-height: 19px;
			letter-spacing: 0px;
			&-title
				width 76px
				flex none
			&-value
				flex 1
				font-family PingFangSC-Medium
				font-size 18px
				font-weight normal
				line-height 24px
				letter-spacing 0px
				color #333333
				display flex
				align-items flex-end
				&.disabled
					color #999
				.week
					font-family PingFangSC-Regular
					font-size 13px
					line-height 19px
					margin-left 7px
			&-icon
				flex none
				width 20px
				height 20px
				display flex
				align-items center
				justify-content center
		.submit-button
			font-size 16px
			font-weight 600
			text-align center
			color white
			border-width 0px
			border-radius 8px
			margin-top 16px
			&.active
				background-color $current-main-color
</style>
<script name='json'>
	module.exports = {
		component: true,
		usingComponents: {
			'es-button': '@didi/es-mpx-ui/lib/button',
		}
	}
</script>